import React from 'react'
import { Table, Menu, ActionIcon, Anchor, Text, Box, NumberFormatter } from '@mantine/core'
import { IconDotsVertical, IconPencil, IconTrash } from '@tabler/icons-react'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'  

const ActionMenu = ({ handleAction, detail }) => {
  return (
    <Menu width={150} position="bottom-end" withArrow arrowPosition="center">
      <Menu.Target>
        <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
          <IconDotsVertical stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconPencil stroke={1.5} size={14} />}
          onClick={() => handleAction('edit')}
          fw='600'
          fz={11}
        >
          Edit
        </Menu.Item>
        <Menu.Item
          color='red'
          leftSection={<IconTrash stroke={1.5} size={14} />}
          onClick={() => handleAction('delete')}
          fw='600'
          fz={11}
        >
          Delete
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

const OrderPaymentHistoryTable = ({ label, data, actionMethod }) => {
  const navigate = useNavigate()
  
  const mappingTableHead = (data) => data.map((val, index) => {
    return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
  })

  const mappingDataTable = (data) => data.map((val, index) => {
    const toDetailUser = (dataUser) => {
      if (dataUser !== null) {
        navigate(`/users/${dataUser.id}`)
      }
    }
    return (
      <Table.Tr key={index}>
        <Table.Td>{val.id}</Table.Td>
        <Table.Td tt='capitalize'>{val.label}</Table.Td>
        <Table.Td tt='capitalize'>{val.method}</Table.Td>
        <Table.Td>{val.paid_at}</Table.Td>
        <Table.Td><NumberFormatter prefix={`${val.currency.toUpperCase()} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={val.value} /></Table.Td>
        <Table.Td>{val.note ? val.note : '-'}</Table.Td>
        <Table.Td >
          <Box>
            <Anchor fz={13} underline="hover" c={val.creator !== null ? 'blue' : 'gray.6'} mb={4} fw='500' onClick={() => toDetailUser(val.id)}>{val.creator !== null ? val.creator.name : 'Created By System'}</Anchor>
            <Text fz={10} c='gray.6'>{dayjs(val.created_at).format('DD/MMMM/YYYY')} - { dayjs(val.created_at).format('HH:mm:ss')}</Text>
          </Box>
        </Table.Td>
        <Table.Td >
          <Box>
            <Anchor fz={13} underline="hover" c={val.updater !== null ? 'blue' : 'gray.6'} mb={4} fw='500' onClick={() => toDetailUser(val.id)}>{val.updater !== null ? val.updater.name : 'Unknown User'}</Anchor>
            <Text fz={10} c='gray.6'>{dayjs(val.updated_at).format('DD/MMMM/YYYY')} - { dayjs(val.updated_at).format('HH:mm:ss')}</Text>
          </Box>
        </Table.Td>
        <Table.Td><ActionMenu handleAction={(type) => actionMethod(val, type)} /></Table.Td>
      </Table.Tr>
    )
  })

  return (
    <Table.ScrollContainer minWidth={1366} type='native'>
      <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
        <Table.Thead style={{ backgroundColor: '#eeefef' }}>
          <Table.Tr>
            {mappingTableHead(label)}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody style={{ verticalAlign: 'top' }}>
          {mappingDataTable(data)}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  )
}

export default OrderPaymentHistoryTable